// extracted by mini-css-extract-plugin
module.exports = {"itemUp":"ProgressBar-module__itemUp___1y1dw","itemDown":"ProgressBar-module__itemDown___26XDE"};